import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  padding: 0;
  margin: 40px 0 0 0;
  max-width: 100%;
  text-align: justify;

  ${media.medium`
    ${({ marginTop }) => marginTop ? `margin: ${marginTop}px 0 0` : `margin: 0`};
    padding: 0 0 0 6vw;
    flex: 0.58;
    max-width: 58%;
    vertical-align: right;
  `}
`;
